import {
  cancelOfflineReservation,
  createOfflineReservation,
  fetchProviderAvailableSlots,
} from "@/api/providerDashboard";

function getResponseMessage(error) {
  return (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message
  );
}

export default {
  openOfflineReservationDialog() {
    const today = this.moment().format("YYYY-MM-DD");
    this.offlineReservationDate =
      this.date && this.date >= today ? this.date : today;
    this.offlineReservationTime = "";
    this.offlineReservationMemo = "";
    this.offlineAvailableSlots = [];
    this.showOfflineReservationDialog = true;
    this.loadOfflineAvailableSlots();
  },
  closeOfflineReservationDialog() {
    if (this.savingOfflineReservation) return;
    this.showOfflineReservationDialog = false;
    this.offlineReservationDate = "";
    this.offlineReservationTime = "";
    this.offlineReservationMemo = "";
    this.offlineAvailableSlots = [];
    this.loadingOfflineSlots = false;
  },
  async loadOfflineAvailableSlots() {
    const requestedDate = this.offlineReservationDate;
    this.offlineReservationTime = "";
    this.offlineAvailableSlots = [];
    if (!requestedDate) return;

    this.loadingOfflineSlots = true;
    try {
      const res = await fetchProviderAvailableSlots(requestedDate);
      if (this.offlineReservationDate !== requestedDate) return;
      this.offlineAvailableSlots = (res.data.data || []).filter(
        (slot) => slot.available
      );
    } catch (error) {
      this.$message.error(
        getResponseMessage(error) || "예약 가능 시간을 불러오지 못했습니다."
      );
    } finally {
      if (this.offlineReservationDate === requestedDate) {
        this.loadingOfflineSlots = false;
      }
    }
  },
  async submitOfflineReservation() {
    if (!this.offlineReservationDate || !this.offlineReservationTime) {
      this.$message.warning("날짜와 시간을 선택해 주세요.");
      return;
    }

    this.savingOfflineReservation = true;
    try {
      const savedDate = this.offlineReservationDate;
      await createOfflineReservation({
        date: savedDate,
        time: this.offlineReservationTime,
        memo: this.offlineReservationMemo,
      });
      this.date = savedDate;
      this.showOfflineReservationDialog = false;
      this.offlineReservationDate = "";
      this.offlineReservationTime = "";
      this.offlineReservationMemo = "";
      this.offlineAvailableSlots = [];
      this.loadingOfflineSlots = false;
      this.$message.success("오프라인 예약을 등록했습니다.");
      await this.loadSchedules();
    } catch (error) {
      this.$message.error(
        getResponseMessage(error) || "오프라인 예약을 등록하지 못했습니다."
      );
      await this.loadOfflineAvailableSlots();
    } finally {
      this.savingOfflineReservation = false;
    }
  },
  async handleCancelOfflineReservation(item) {
    if (!item || item.bookingType !== "offline") return;
    try {
      await this.$confirm("이 오프라인 예약을 취소하시겠습니까?", {
        confirmButtonText: "예약 취소",
        cancelButtonText: "닫기",
        type: "warning",
      });
      await cancelOfflineReservation(item._id);
      this.$message.success("오프라인 예약을 취소했습니다.");
      await this.loadSchedules();
    } catch (error) {
      const responseMessage = getResponseMessage(error);
      if (responseMessage) {
        this.$message.error(responseMessage);
        await this.loadSchedules();
      }
    }
  },
};
